import { createActions, handleActions } from "redux-actions";
import { find } from "lodash-es";

export const actionCreators = createActions({
  DASHBOARD: {
    PANEL: {
      ENABLE: (params) => params,
      DISABLE: (params) => params,
      TOGGLE: (params) => params,
      QUERY: {
        INDICATOR: (params) => params,
        SITUATION: (params) => params,
        TEMPERATURE: (params) => params,
        ORDER: (params) => params,
        OPERATION: (params) => params,
        IMAGE: (params) => params,
        SIZE: (params) => params,
      },
    },
  },
});

const reducer = handleActions(
  {
    DASHBOARD: {
      PANEL: {
        ENABLE: (state, action) => {
          return { ...state };
        },
        DISABLE: (state, action) => {
          return { ...state };
        },
        TOGGLE: (state, action) => {
          const { layerGroup, name } = action.payload;
          const { panels } = state;
          const current = find(panels, (value, key) => {
            return key === layerGroup;
          });
          current[name] = !current[name];
          return {
            ...state,
            panels: { ...panels, [layerGroup]: { ...current } },
          };
        },
      },
    },
  },
  {
    panels: {
      concentration: {
        timeline: true,
      },
      thickness: {
        timeline: true,
      },
      wind: {
        timeline: true,
      },
      route: {
        risk: true,
        buffer: false,
        ice: true,
        weather: true,
        routeDate: true,
        indicator: false,
        timeline: true,
        flow: false,
      },
      remote: {
        step: true,
        center: true,
        archStep: false,
        order: true,
      },
      temperature: {
        timeline: true,
      },
      navigator: {
        form: true,
      },
    },
  }
);

export default reducer;
